import { useParams } from 'react-router';

import { enqueueSnackbar } from 'notistack';

import { useShowError } from 'hooks/useShowError';
import { useFormMutation } from 'mutations/useFormMutation';
import { useDreFormContext } from 'pages/financeiro/dre/contexts';
import { RequestDreForm } from 'pages/financeiro/dre/types';

export function useLoadF360() {
    const { mutate, isLoading } = useFormMutation<RequestDreForm>();
    const { setDre, setDreStatus, setStatus } = useDreFormContext();
    const { id } = useParams();
    const { showError } = useShowError();

    /**
     * Carrega as despesas do F360.
     */
    const loadF360 = () => {
        setStatus('RECALCULATING');

        mutate(
            { url: `/dre/dremercadologicawrapper/atualizadespesaexterna?idDreMercadologica=${id}`, preventSnack: true },
            {
                onSuccess: ({ data, status }) => {
                    enqueueSnackbar('Desespesas do F360 carregadas com sucesso!', { variant: 'success' });

                    setDre(data.data);
                    setDreStatus(status);
                },
                onError: (error) => showError(error, 'Falha ao carregar as desespesas do F360'),
                onSettled: () => setStatus(null),
            },
        );
    };

    return { loadF360, isLoading };
}
